import './App.css';
import Developers from './components/Developers/Developers';
import Header from './components/Header/Header';

function App() {
  return (
    <div className="App">
      <Header />
      <Developers />
    </div>
  );
}

export default App;
